/**
 * /sample-report — full-page realistic Executive Growth Report™ preview.
 *
 * Reuses the production `<Report />` component by passing the curated
 * SAMPLE_LEAD payload via its `sampleData` prop. Adds a top banner so
 * onboarding consultants know they are viewing a demonstration and can
 * jump back to their onboarding flow with one click.
 */
import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Sparkles } from "lucide-react";
import { Button } from "../components/ui/button";
import Report from "./Report";
import { SAMPLE_LEAD } from "../lib/sample-report-data";

export default function SampleReport() {
  return (
    <div data-testid="sample-report-page">
      {/* Sample banner */}
      <div
        className="w-full border-b border-accent/30 bg-accent/10"
        data-testid="sample-report-banner"
      >
        <div className="max-w-5xl mx-auto px-6 py-3 flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-2 text-sm text-foreground font-sans-ui">
            <Sparkles className="w-4 h-4 text-accent" />
            <span className="font-semibold">Sample report</span>
            <span className="text-muted-foreground">
              — this is what a business leader will see once they complete
              your diagnostic.
            </span>
          </div>
          <Link to="/onboarding/welcome" data-testid="sample-report-back">
            <Button variant="ghost" size="sm">
              <ArrowLeft className="w-4 h-4 mr-2" /> Back to onboarding
            </Button>
          </Link>
        </div>
      </div>

      <Report sampleData={SAMPLE_LEAD} />
    </div>
  );
}
